const tailwindExtensions = {
  colors: {
    "primary": "#26e3ba",
    "primary-txt": "#3af8cf",
    "primary-btn": "#58fdd9",
    "primary-dark": "#130c21",
    "secondary": "#242424",
    "boost-primary-purple": "#4B2BA3",
    "boost-purple-alt": "#7947FE",
    "boost-light": "#FAF8FF",
    "boost-secondary": "#BD95F8",
    "boost-txt-white": "#EEFFFC",
    "boost-price-green": "#87DDA4",
    "boost-button-purple": "#7249F5",
    "boost-button-purple-hover": "#8E6DF7",
    "text": "#040404",
    "black-bg": "#070C0B",
    "background": "#070C0B",
    "black-btn": "#242424",
    "icon": "#00766a",
    "bgreen": "#58FDD9",
    "greenHover": "#9fffea",
    "green-primary": "#26E3BA",
    "green-secondary": "#BFF1E7",
    "green-boost-btn": `#00A588`,
    "green-dark": "#001713",
    "black-primary": "#011516",
    "black-secondary": "#030E0E",
    "gray-boost-text": "#6A6A6A",
    "boost-input-gray": "#D9D9D9",
    "boost-text-gray": "#818181",
    "off-white": "#FCFCFC",
    "gray-primary": "#7aa4a7",
    "gray-secondary": "#D8D8D8",
    "support": "#152D2D",
    "critical": "#FF8080",
    "warning": "#FFCC67",
    "fog-gray": "#DAE1E9",
    "beige": "#FFF0D5",
    "boost-primary": "#4B2BA3",
    "boost-light-purple": "#8154FE",
    "boost-lighter-purple": "#B296FF",
    "boost-gold": "#8C6D00",
    "boost-light-gold": "#E1AF00",
    "boost-black": "#020202",
    "boost-trial-ending-red": "#FF8D93",
    "stripe-error-red": "#DF1B41",
    /*
      below are colors from design doc Earth 1.0
      https://www.figma.com/file/YdAGQzOd0bkXHPEdvpkV92/Earth-(1.0)
      may have some overlaps with the existing. should migrate to the new color classname
    */
    // neutral
    "neutral-700": "#1F1F1F",
    "neutral-600": "#4B4B4B",
    "neutral-500": "#8E8E8E",
    "neutral-400": "#CACACA",
    "neutral-300": "#E1E1E1",
    "neutral-200": "#EEEEEE",
    "neutral-100": "#F5F5F5",
    "neutral-50": "#FAFAFA",
    // primary
    "boost-primary-700": "#472C9B",
    "boost-primary-600": "#5C3BC8",
    "boost-primary-500": "#7249F5",
    "boost-primary-400": "#8E6DF7",
    "boost-primary-300": "#AA92F9",
    "boost-primary-200": "#C7B6FB",
    "boost-primary-100": "#E3DBFD",
    "boost-primary-50": "#F1EDFE",
    // error
    "error-700": "#8C3133",
    "error-600": "#B74143",
    "error-500": "#E25153",
    "error-400": "#E87475",
    "error-300": "#EE9798",
    "error-200": "#F3B9BA",
    "error-100": "#F9DCDD",
    "error-50": "#FCEEEE",
    // warning
    "warning-700": "#FE9B0E",
    "warning-600": "#FFAD0D",
    "warning-500": "#FFC62B",
    "warning-400": "#FFDD82",
    "warning-300": "#FFEAB3",
    "warning-200": "#FFF7E1",
    "warning-100": "#FFF9EE",
    "warning-50": "#FFFDFA",
    // success
    "success-700": "#0C9D61",
    "success-600": "#47B881",
    "success-500": "#6BC497",
    "success-400": "#97D4B4",
    "success-300": "#C0E5D1",
    "success-200": "#E5F5EC",
    "success-100": "#F2FAF6",
    "success-50": "#FBFEFC",
    // information
    "info-700": "#3A70E2",
    "info-600": "#3B82F6",
    "info-500": "#4BA1FF",
    "info-400": "#93C8FF",
    "info-300": "#BDDDFF",
    "info-200": "#E4F2FF",
    "info-100": "#F1F8FF",
    "info-50": "#F8FCFF",
  },
  boxShadow: {
    // primary: "0px 32px 94px #132A27",
    // secondary: "0px -48px 44px #1D3532",
    "xl-around": "0 0 25px 0 rgba(0, 0, 0, 0.15)",
    "2xl-around": "0 0 50px 0 rgba(0, 0, 0, 0.25)",
    "faint": "0 39px 142px 38px rgba(27, 15, 50, 0.1)",
  },
};

const screens = {
  // => @media (min-width: 350px) { ... }
  xs: "350px",
  // => @media (min-width: 640px) { ... }
  sm: "640px",
  // => @media (min-width: 768px) { ... }
  md: "768px",
  // => @media (min-width: 850px) { ... }
  mdl: "850px",
  // => @media (min-width: 1024px) { ... }
  lg: "1024px",
  // => @media (min-width: 1280px) { ... }
  xl: "1280px",
  // => @media (min-width: 1366px) { ... }
  xxl: "1366px",
  // Add custom screen sizes here, in the format:
  // 'sm300-400': {'min': '300px', 'max': '4000px'},
  // Tailwind uses min-width by default
};

const theme = {
  maxWidth: {
    "1/2": "50%",
  },
};

export default { tailwindExtensions, screens, theme };
